if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function(){

    /*
        HOME ARROW
        $('.arrow-home').click(function(event) {
            $('body, html').animate({
                scrollTop: $(window).height()-$('header').outerHeight()*2},
                800, 'easeOutExpo');
        });
    */

    document.querySelectorAll('.highlights__tabs li').forEach((btn, i) => {
        btn.addEventListener('click', _ => {
            document.querySelectorAll('.highlights__tabs li').forEach(b => b.classList.remove('active'));
            btn.classList.add('active');

            document.querySelectorAll('.highlights__item').forEach(item => {
                item.classList.remove('active');
                if ( btn.dataset.tag === 'all' || item.dataset.tag.includes(btn.dataset.tag)) {
                    item.classList.add('active');
                }
            });
        });

        if (i === 0) btn.click();
    });

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));

    document.addEventListener('DOMContentLoaded', function() {
        const toggleButtonReserve = document.getElementById("btn-reserve");
        const formContainer = document.querySelector('.form-container');
        const textReserve = document.getElementById("btn-reserve");
        if(toggleButtonReserve){
            toggleButtonReserve.addEventListener("click", function() {
                if (formContainer.classList.contains("active")) {
                    textReserve.textContent = "book now";
                    formContainer.classList.remove("active");
                    toggleButtonReserve.classList.remove("active");
                } else {
                    textReserve.textContent = "close";
                    formContainer.classList.add("active");
                    toggleButtonReserve.classList.add("active");
                }
            });
        }

        const mobileButton = document.getElementById('menu-btn');
        const mobileNav = document.querySelector('.mobile-nav');
        if (mobileButton) {
            mobileButton.addEventListener('click', function(){
                if (mobileNav.classList.contains("active")) {
                    mobileButton.textContent = "menu";
                    mobileNav.classList.remove("active");
                    mobileButton.classList.remove("active");
                } else {
                    mobileButton.textContent = "close";
                    mobileNav.classList.add("active");
                    mobileButton.classList.add("active");
                }
            });
        }

        let scrollButtons = document.querySelectorAll('.js-scroll');

        if(scrollButtons.length > 0){
            scrollButtons.forEach((button)=>{
                button.addEventListener('click', (e)=>{
                    e.preventDefault();
                    let data = button.getAttribute('href').split('#')[1];
                    let target = document.getElementById(data);
                    let headerHeight = document.querySelector('header').offsetHeight;
    
                    window.scrollTo({
                        top: target.offsetTop - headerHeight,
                        behavior: 'smooth'
                    });
                });
            });
        }

        var data = document.URL;

        if(data.indexOf("?filter") != -1 && document.querySelector('.highlights')){
            let dataFilter = data.split('?filter=')[1];
            document.querySelector('[data-tag="'+dataFilter+'"]').click();
            let target = document.querySelector('.highlights__tabs');
            let headerHeight = document.querySelector('header').offsetHeight + 50;

            window.scrollTo({
                top: target.offsetTop - headerHeight,
                behavior: 'smooth'
            });
        }
        
        // for input label in mobile
        if (window.innerWidth <= 767) {
            let dateInputs = document.querySelectorAll('input[type="date"], input[type="time"]');
            dateInputs.forEach(function(input) {
                input.addEventListener('input', function() {
                    if (input.value.length > 0) {
                        input.classList.add('full');
                    } else {
                        input.classList.remove('full');
                    }
                });
            });
        }

        let pinItems = document.querySelectorAll(".pin-item");
        let pinTabs = document.querySelectorAll('.pin-tab');
    
        if (pinItems.length > 0) {
            pinItems.forEach(function(pinItem) {
                let icon = pinItem.querySelector(".icon");
                let lightboxContent = pinItem.querySelector(".lightbox-content");
    
                icon.addEventListener("click", function() {
                    document.querySelectorAll(".lightbox-content.active").forEach(function(otherLightbox) {
                        otherLightbox.classList.remove("active");
                    });
                    document.querySelectorAll(".icon.active").forEach(function(otherIcon) {
                        otherIcon.classList.remove("active");
                    });
                    lightboxContent.classList.toggle("active");
                    icon.classList.toggle("active");
                });
                
                var closeButton = lightboxContent.querySelector('.close');
                if (closeButton) {
                    closeButton.addEventListener('click', function() {
                        lightboxContent.classList.remove('active');
                        icon.classList.remove('active');
                    });
                }
            });
        }
    
        if (pinTabs.length > 0) {
            pinTabs.forEach(function(tab) {
                tab.addEventListener('click', function() {
                    let dataId = this.getAttribute('data-id');
                    let lightboxContents = document.querySelectorAll('.lightbox-content');
    
                    // Alternar la clase active en el lightbox correspondiente al data-id clicado
                    lightboxContents.forEach(function(content) {
                        if (content.getAttribute('data-id') === dataId) {
                            content.classList.add('active');
                        } else {
                            content.classList.remove('active');
                        }
                    });
                });
            });
        }   
    });


    /* LIGHTBOX */

	if(document.getElementsByClassName('lightbox').length > 0){
		let allLightboxes = document.getElementsByClassName('js-lightboxbtn');
		let allLightboxesLength = allLightboxes.length;

		for(let j = 0; j < allLightboxesLength; j++ ){
			allLightboxes[j].addEventListener('click', function(e){
				e.preventDefault();
				let currentTarget = this.getAttribute('href').split('#')[1];
				document.getElementById(currentTarget).classList.add('open');
				document.body.classList.add('no-scroll');
			});

		}

		let allLightcloses = document.getElementsByClassName('js-lightboxclose');
		let allLightclosesLength = allLightcloses.length;

		for(let j = 0; j < allLightclosesLength; j++ ){
			allLightcloses[j].addEventListener('click', function(e){
				e.preventDefault();
				let currentTarget = this.parentElement.parentElement.id;
				document.getElementById(currentTarget).classList.remove('open');
				document.body.classList.remove('no-scroll');
			});
		}

		let allLbxWraps = document.querySelectorAll('.lightbox');

		for(const lbxWrap of allLbxWraps) {
			lbxWrap.addEventListener('click', (e) => {
				const innerWrap = lbxWrap.querySelector('.lightbox-wrap') ;
				if(!innerWrap.contains(e.target)) {
					allLbxWraps.forEach(el => el.classList.remove('open'));
					document.body.classList.remove('no-scroll');
				}
			})
		}

	};
    
    // $('.sym-slides.slider').slick("refresh");
    // tpl gallery 
    if (typeof customLightbox !== 'undefined') {
		customLightbox.fullScreen = true;
	}



    function scrollToAndClickElementFromTabParam() {
        const urlParams = new URLSearchParams(window.location.search);
        const tabId = urlParams.get('tab');
      
        if (tabId) {
          const element = document.getElementById(tabId);
      
          if (element) {
            
            const yOffset = -250; 
            const elementPosition = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
      
           
            window.scrollTo({ top: elementPosition, behavior: 'smooth' });
            element.click();

          } else {
            console.log('No element with that ID.');
          }
        } else {
          console.log('parameter "tab" no exist in the url.');
        }
      }
      
      // Llamar a la función cuando la página esté completamente cargada
      window.onload = scrollToAndClickElementFromTabParam;
      
})();